module.exports = __webpack_public_path__ + "static/media/pic-1.f8f02a05.jpg";